<template>
  <div :id="id">
  </div>
</template>

<script>
import { css_beautify, html_beautify, } from 'js-beautify'
import 'grapick/dist/grapick.min.css'
import grapesjsCustomCode from 'grapesjs-custom-code'
import grapesjsParserPostCss from 'grapesjs-parser-postcss'
import grapesjsTuiImageEditor from 'grapesjs-tui-image-editor'
import grapesjsStyleBg from 'grapesjs-style-bg'

export default {
  name: 'HtmlEditor',
  props: {
    id: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    globalStyles: {
      type: String,
      required: false,
    }
  },
  data() {
    const route = this.$router.resolve({ 
      name: 'ImageManager',
    })
    return {
      filebrowserBrowseUrl: route.href,
      editor: null,
    }
  },
  methods: {
    change() {
      if (this.editor != null) {
        this.$emit('change', html_beautify(this.editor.getHtml()), css_beautify(this.editor.getCss()));
      }
    },
    popupCenter (url, title, w, h) {
      // Fixes dual-screen position                             Most browsers      Firefox
      const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
      const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

      const systemZoom = width / window.screen.availWidth;
      const left = (width - w) / 2 / systemZoom + dualScreenLeft
      const top = (height - h) / 2 / systemZoom + dualScreenTop
      window.open(url, title, 
        `
        scrollbars=yes,
        width=${w / systemZoom}, 
        height=${h / systemZoom}, 
        top=${top}, 
        left=${left}
        `
      )
    }
  },
  beforeDestroy() {
    if (this.editor != null) {
      try {
        this.editor.destroy()
      } catch (ignored) {}
      this.editor = null
    }
  },
  mounted() {
    const lp = './img/'
    const plp = '//placehold.it/350x250/'
    const images = [
      lp+'team1.jpg', lp+'team2.jpg', lp+'team3.jpg', plp+'78c5d6/fff/image1.jpg', plp+'459ba8/fff/image2.jpg', plp+'79c267/fff/image3.jpg',
      plp+'c5d647/fff/image4.jpg', plp+'f28c33/fff/image5.jpg', plp+'e868a2/fff/image6.jpg', plp+'cc4360/fff/image7.jpg',
      lp+'work-desk.jpg', lp+'phone-app.png', lp+'bg-gr-v.png'
    ]

    this.editor = window.grapesjs.init({
        protectedCss: '',
        avoidInlineStyle: 1,
        height: '100%',
        showOffsets: 1,
        noticeOnUnload: 0,
        container : '#' + this.id,
        fromElement: 0,
        showDevices: false,
        storageManager: 0,
        assetManager: {
          embedAsBase64: 1,
          assets: images
        },
        selectorManager: { componentFirst: true },
        plugins: [
          'grapesjs-blocks-bootstrap4',
          grapesjsCustomCode,
          grapesjsParserPostCss,
          grapesjsTuiImageEditor,
          grapesjsStyleBg,
        ],
        pluginsOpts: {
          'grapesjs-blocks-bootstrap4': {
              blocks: {},
              blockCategories: {},
              labels: {},
              gridDevicesPanel: true,
              formPredefinedActions: [
                  {name: 'Contact', value: '/contact'},
                  {name: 'landing', value: '/landing'},
              ]
          },
        },
        canvas: {
            styles: [
                'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css'
            ],
            scripts: [
                'https://code.jquery.com/jquery-3.3.1.slim.min.js',
                'https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js',
                'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js'
            ],
          },
      })

    const head = editor.Canvas.getDocument().head
    if (this.globalStyles) {
      head.insertAdjacentHTML('beforeend', `<style>${this.globalStyles}</style>`)


    }
    editor.addComponents(this.content)

    this.editor.on('change', this.change)
    const $this = this
    this.editor.Commands.add('open-assets', {
      run(editor) {
        if (editor.getSelected()) {
          if (editor.getSelected().get('src')) {
            window.UPDATE_IMAGE_ACTION = (url) => {
              editor.getSelected().set('src', url)
            }
          } else {
            window.UPDATE_IMAGE_ACTION = (url) => {
              editor.getSelected().addStyle({'background-image': 'url(' + url + ')'})
              window.UPDATE_IMAGE_ACTION = null
            }
          }
          $this.popupCenter($this.filebrowserBrowseUrl, '_blank', 800, 600)
        }
      }
    })
  }
}
</script>